import React from "react";
import SpecManagerInput from "./SpecManagerInput";
import { UNIT_OPTIONS } from "./Helper";
import "./SpecsQuantitative.css";
import SpecManagerSelect from "./SpecManagerSelect";

export default class SpecsQuantitative extends React.Component {
  onRangeOptionClick = (optionSelected) => {
    const { data, handleDataChange } = this.props;
    handleDataChange([optionSelected, data[1], data[2]]);
  }

  onUnitOptionClick = (optionSelected) => {
    const { data, handleDataChange } = this.props;
    handleDataChange([data[0], data[1], optionSelected]);
  }

  onInputChange = (value) => {
    const { data, handleDataChange } = this.props;
    handleDataChange([data[0], value, data[2]]);
  }

  render() {
    const { data } = this.props;
    const [max, number, unit] = data;

    return (
      <div
        className="environmentReportSpecManagerContainer"
        id="environmentReportSpecManagerSpecsQuantitative"
      >
        <SpecManagerSelect
          width="152px"
          options={["Max", "Min"]}
          optionSelected={max || "Max"}
          onSelect={this.onRangeOptionClick}
        />
        <SpecManagerInput
          placeHolder="eg: 20"
          onChange={this.onInputChange}
          value={number}
          width="72px"
        />
        <SpecManagerSelect
          width="114px"
          optionSelected={unit || "None"}
          options={UNIT_OPTIONS}
          onSelect={this.onUnitOptionClick}
        />
      </div>
    );
  }
}
